/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteSprintGoalInput = {
    id: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type DeleteSprintGoalMutationVariables = {
    input: DeleteSprintGoalInput;
};
export type DeleteSprintGoalMutationResponse = {
    readonly deleteSprintGoal: {
        readonly deletedSprintGoalId: string | null;
    } | null;
};
export type DeleteSprintGoalMutation = {
    readonly response: DeleteSprintGoalMutationResponse;
    readonly variables: DeleteSprintGoalMutationVariables;
};



/*
mutation DeleteSprintGoalMutation(
  $input: DeleteSprintGoalInput!
) {
  deleteSprintGoal(input: $input) {
    deletedSprintGoalId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteSprintGoalInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSprintGoalPayload",
    "kind": "LinkedField",
    "name": "deleteSprintGoal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSprintGoalId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteSprintGoalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteSprintGoalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DeleteSprintGoalMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteSprintGoalMutation(\n  $input: DeleteSprintGoalInput!\n) {\n  deleteSprintGoal(input: $input) {\n    deletedSprintGoalId\n  }\n}\n"
  }
};
})();
(node as any).hash = '7a15d43aafe08091b14070ce1d097112';
export default node;
